import RCTimeline, {
  TimelineHeaders,
  DateHeader,
  SidebarHeader,
  TimelineMarkers,
  TodayMarker,
  CustomMarker,
  CursorMarker,
} from 'react-calendar-timeline';

import 'react-calendar-timeline/style.css';

/**
 * Timeline — wrapper di `react-calendar-timeline` con CSS centralizzato.
 *
 * Per ora il wrapper è una pass-through: la libreria espone API ricca
 * (groupRenderer, itemRenderer, sidebarWidth, defaultTimeStart/End,
 * onTimeChange, …) e i consumer la usano nel modo specifico per la
 * loro feature. Qui centralizziamo solo l'import del CSS, che era
 * sparso in 46 file legacy.
 *
 * I sotto-componenti TimelineHeaders / DateHeader / TimelineMarkers /
 * TodayMarker / CustomMarker / CursorMarker / SidebarHeader sono
 * re-esportati per ergonomia.
 */
export default RCTimeline;

export {
  TimelineHeaders,
  DateHeader,
  SidebarHeader,
  TimelineMarkers,
  TodayMarker,
  CustomMarker,
  CursorMarker,
};
